import { BUSINESS_INTEGRATION_RYFT_NON_HOSTED_ACCOUNTS } from "~/constants/routes";
import { Alert } from "~/components/alert/Alert";
import { apiV2AssertError } from "~/hooks/api/v2/apiV2Request";
import { Navigate, Outlet } from "react-router";
import { RyftNonHostedOnboardingProvider } from "./components/RyftNonHostedOnboardingProvider";
import { useRyftNonHostedOnboarding } from "./components/RyftNonHostedOnboardingProvider.shared";
import { ReactNode } from "react";
import { Spinner } from "@sellar-io/components";
import { PageContainer } from "~/components/pageContainer/PageContainer";

export const RyftNonHostedOnboardingLayout = () => {
  return (
    <RyftNonHostedOnboardingProvider>
      <OnboardingLoadingBoundary>
        <Outlet />
      </OnboardingLoadingBoundary>
    </RyftNonHostedOnboardingProvider>
  );
};

const OnboardingLoadingBoundary = ({ children }: { children: ReactNode }) => {
  const { isLoading, account, error } = useRyftNonHostedOnboarding();

  if (isLoading) {
    return (
      <PageContainer className="flex min-h-96 items-center justify-center">
        <Spinner />
      </PageContainer>
    );
  }

  if (error) {
    const apiError = apiV2AssertError(error);
    const message = apiError?.response?.data.message;
    const isNewAccount =
      apiError?.response?.status === 400 &&
      message ===
        "This supplier does not have an active API-managed Ryft payout account.";

    if (!isNewAccount) {
      return (
        <PageContainer className="p-4">
          <Alert
            type="error"
            message={message ?? "Unable to load your Ryft account"}
          />
        </PageContainer>
      );
    }
  }

  if (account?.termsOfService?.acceptance) {
    return (
      <Navigate to={BUSINESS_INTEGRATION_RYFT_NON_HOSTED_ACCOUNTS} replace />
    );
  }

  return <>{children}</>;
};
